<div class="top-title-with-buttons d-block w-100">
  <div class="buttons-container w-100 gap-4" [ngClass]="{ 'flex-column': lineBreakBtns }" *ngIf="btnList?.length && !hideBtnListOnDesktop">
    <ng-container *ngTemplateOutlet="contentAboveButtons"></ng-container>

    <ng-container *ngFor="let btnItem of btnList">
      <button [disabled]="dataShimmer || isBtnListDisabled || shouldDisableButton(btnItem)"
          (click)="$event.stopPropagation();btnFunctionCalled(btnItem.fctName, btnItem?.fctData)"
          *ngIf="shouldShowButton(btnItem) && !btnItem?.isHiddenOnDesktop"
          class="{{btnItem.className ? btnItem.className : 'foo-btn-primary'}}">
          <img *ngIf="btnItem.imagePath" src="{{btnItem.imagePath}}"
              class="svg-color-filter" [alt]="btnItem.imagePath" />
          <span *ngIf="btnItem.icon" class="foo-icon foo-{{btnItem.icon}}"></span>
          <span *ngIf="btnItem.title">{{btnItem.title | translate}}</span>
      </button>
    </ng-container>
  </div>
  <div class="row responsive-buttons responsive-buttons-container" (window:resize)="setPageContentMargin()" *ngIf="btnList?.length && !hideBtnListOnMobile">

    <div class="buttons-container flex-row flex-wrap align-items-center justify-content-center gap-4" [ngClass]="{ 'flex-column': lineBreakBtns }">
      <ng-container *ngTemplateOutlet="contentAboveButtons"></ng-container>

      <ng-container *ngFor="let btnItem of btnList">
        <button [disabled]="dataShimmer || isBtnListDisabled || shouldDisableButton(btnItem)"
            (click)="$event.stopPropagation();btnFunctionCalled(btnItem.fctName, btnItem?.fctData)"
            *ngIf="shouldShowButton(btnItem) && !btnItem?.isHiddenOnMobile"
            [ngClass]="btnItem.responsiveClassName ? btnItem.responsiveClassName : (btnItem.className ? btnItem.className : 'foo-btn-primary')"
            class="m-2">
            <img *ngIf="btnItem.imagePath" src="{{btnItem.imagePath}}"
                class="svg-color-filter" [alt]="btnItem.imagePath" />
            <span *ngIf="btnItem.icon" class="foo-icon foo-{{btnItem.icon}}"></span>
            <span *ngIf="btnItem.title">{{ btnItem.title | translate }}</span>
        </button>
      </ng-container>
    </div>
  </div>
</div>
